/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';
import { Pasos } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import styles from './renderHistorialPasos.module.scss'; // ajusta si lo mueves

interface HistorialPasosProps {
  pasos: Pasos[];
}

// Define enum or mapping for pasos
const PasoLabels: Record<number, string> = {
  1: I18n.t('PasosOnboarding.DATOS INICIALES'),
  2: I18n.t('PasosOnboarding.DATOS DE FACTURA'),
  3: I18n.t('PasosOnboarding.ENCUESTA OBLIGATORIA'),
  4: I18n.t('PasosOnboarding.SELECCIÓN COMUNIDAD'),
  5: I18n.t('PasosOnboarding.ACCESO DATADIS'),
  6: I18n.t('PasosOnboarding.ACEPTACIÓN OFERTAS'),
  7: I18n.t('PasosOnboarding.FIRMA CONTRATO'),
  8: I18n.t('PasosOnboarding.DOCUMENTO REPARTO'),
};

export const HistorialPasos = ({ pasos }: HistorialPasosProps) => {
  if (!pasos || pasos.length === 0) {
    return <p>{I18n.t('No hay historial disponible')}</p>;
  }

  return (
    <div className={styles.historialContainer}>
      <table className={styles.historialTable}>
        <thead>
          <tr>
            <th>{I18n.t('Paso')}</th>
            <th>{I18n.t('Fecha inicio')}</th>
            <th>{I18n.t('Fecha fin')}</th>
            <th>{I18n.t('Estado')}</th>
            <th>{I18n.t('Errores')}</th>
            <th>{I18n.t('Nº Mensajes')}</th>
          </tr>
        </thead>
        <tbody>
          {pasos.map((paso) => (
            <tr key={paso.id}>
              <td>{PasoLabels[Number(paso.paso)]}</td>
              <td>{paso.fecha_start ? new Date(paso.fecha_start).toLocaleString() : '—'}</td>
              <td>{paso.fecha_finish ? new Date(paso.fecha_finish).toLocaleString() : '—'}</td>
              <td>{paso.acabado ? `✅ ${I18n.t('Completado')}` : `⏳ ${I18n.t('Pendiente')}`}</td>
              <td>
                {paso.mensajes_de_error?.length > 0 ? (
                  <ul className={styles.errorList}>
                    {paso.mensajes_de_error.map((error, i) => (
                      <li key={i}>{error}</li>
                    ))}
                  </ul>
                ) : (
                  '—'
                )}
              </td>
              <td>{paso.numero_de_mesajes_enviados}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistorialPasos;
